import React from "react";
import { Cpu, Globe, Zap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Long-Lasting Durability",
  description: "Our dentures are engineered using premium, medical-grade materials to ensure long-term resilience and a comfortable fit for years of reliable use.",
  icon: Cpu
}, {
  title: "Natural Aesthetics",
  description: "We meticulously craft each set to match your natural gum line and tooth shade, restoring your confidence with a beautiful, lifelike appearance.",
  icon: Globe
}, {
  title: "Simplified Maintenance",
  description: "Experience the convenience of easy-to-clean prosthetics designed for your busy lifestyle, making oral hygiene straightforward and stress-free.",
  icon: Zap
}];
export default function TechnologyExecution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="39298" id="benefits-of-our-dentures" ref={ref} className={`py-24 bg-secondary/30 text-foreground transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold tracking-tight text-primary mb-4">
            Benefits of Our Dentures
          </h2>
          <p className="text-lg md:text-xl font-sans text-muted-foreground">
            Smart Choice Dentures & Implants provides high-quality, affordable solutions tailored to your unique smile in El Monte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full border-border/50 bg-card/60 backdrop-blur-md shadow-lg hover:shadow-xl hover:-translate-y-1 rounded-2xl transition-all duration-300">
                <CardHeader className="pb-2">
                  <div className="w-14 h-14 rounded-full bg-secondary flex items-center justify-center mb-5 text-primary border border-primary/10">
                    <feature.icon className="w-7 h-7" />
                  </div>
                  <CardTitle className="text-2xl font-serif font-medium text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground font-sans">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}